import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/home.css';
import {Container} from 'react-bootstrap';
import HomeVideo from './images/pasada-short.mp4'
// import MainVideo from './images/pasada-full.mp4'
import {HashLink} from "react-router-hash-link";
import Slide from 'react-reveal/Slide';
import { Helmet } from 'react-helmet';


const imgGallery = [
    {
        image: require('./images/DOST-PCIEERD.png'),
        name: "Department of Science and Technology",
        url: "https://www.dost.gov.ph/",
    },
    {
        image: require('./images/tip1.png'),
        name: "Technological Institute of the Philippines",
        url: "https://www.tip.edu.ph/",
    },
];

class Home extends React.Component {

    constructor() {
        super()
        this.state = {hover: null}
    }

    render() {
        return (
            <div class="header">
                <Helmet>
                    <title>{ "PASADA" }</title>
                    <meta name="description" content="PASADA PH Web Application" />
                    <link rel="canonical" href="/"></link>
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
                </Helmet>
                <div class="d-flex">
                    <video autoPlay playsInline loop>
                        <source src={HomeVideo} type='video/mp4'/>
                    </video>
                    <div class="textheader col text-light text-center w-100">
                        <p class="p-5 w-100 poppins">The Next Generation of Public Transportation</p>
                        <p className="textheader2 p-2 opacity-75 ">PASADA revolutionizes modern jeepney and
                            bus <br/> transportation in the Philippines through technology.</p>
                        <a href="#partners" class="btnheader btn btn-primary btn-md active p-3" role="button"
                           aria-pressed="true">Learn More
                            <svg aria-hidden="true" class="iconify iconify--carbon" height="20"
                                 preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 40 35" width="30"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M22 16L12 26l-1.4-1.4l8.6-8.6l-8.6-8.6L12 6z" fill="currentColor"></path>
                            </svg></a>
                    </div>
                </div>

                {/*<div class="d-flex justify-content-center align-items-center p-5 mx-5" id="adv">*/}
                {/*    <div>*/}
                {/*        <h5>The Pasada Advantage</h5>*/}
                {/*    </div>*/}
                {/*    <div class="p-5">*/}
                {/*        <p>PASADA integrates the latest technologies to empower public transportation services, providing a learning content management system and driver performance monitoring to boost road competence.</p>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div class="container-fluid p-5" id="partners">
                    <div class="row d-flex justify-content-center">
                        <h1 class="textp text-center">{this.state.hover ? this.state.hover : "IN PARTNERSHIP WITH"}</h1>
                        {
                            imgGallery.map((index) =>
                                <div class="logom mx-5"
                                     onMouseEnter={() => this.setState({hover: index.name})}
                                     onMouseLeave={() => this.setState({hover: null})}>

                                    <a href={index.url}><img src={index.image} alt="Images"
                                                             class="LOGOS my-3"></img></a>
                                </div>
                            )
                        }
                    </div>
                </div>

                <Slide bottom>
                    <Container>
                    <div className="d-flex flex-column p-5 m-5 justify-content-center align-items-center">
                        <h1 className="mainvid text-uppercase text-dark">WHAT IS PASADA?</h1>
                        <div className="ratio ratio-16x9">
                            <iframe src="https://www.youtube.com/embed/AN7ht86bj2I" title="DOST PASADA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                        </div>
                    </div>
                    </Container>
                </Slide>

                <Slide bottom>
                    <div className="objectives-section p-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 d-flex flex-column justify-content-center">
                                    <div className="objectives-header mb-4">
                                        <h1 className="objectives-title text-uppercase">Our Objectives</h1>
                                    </div>
                                    <div className="objectives-list">
                                        <div className="objective-item d-flex align-items-center mb-3">
                                            <div className="objective-icon safety-icon me-3">
                                                <i className="fas fa-shield-alt"></i>
                                            </div>
                                            <div>
                                                <h5>Enhance <span className="text-primary">Road Safety</span></h5>
                                                <p className="mb-0">Through real-time, data-driven insights.</p>
                                            </div>
                                        </div>
                                        <div className="objective-item d-flex align-items-center mb-3">
                                            <div className="objective-icon efficiency-icon me-3">
                                                <i className="fas fa-cogs"></i>
                                            </div>
                                            <div>
                                                <h5>Boost <span className="text-primary">Efficiency</span></h5>
                                                <p className="mb-0">In Fleet operations and driver performance.</p>
                                            </div>
                                        </div>
                                        <div className="objective-item d-flex align-items-center mb-3">
                                            <div className="objective-icon empower-icon me-3">
                                                <i className="fas fa-user-check"></i>
                                            </div>
                                            <div>
                                                <h5>Empower <span className="text-primary">Drivers</span></h5>
                                                <p className="mb-0">With skill evaluation and feedback tools.</p>
                                            </div>
                                        </div>
                                        <div className="objective-item d-flex align-items-center mb-3">
                                            <div className="objective-icon mobility-icon me-3">
                                                <i className="fas fa-bus"></i>
                                            </div>
                                            <div>
                                                <h5>Build <span className="text-primary">Smarter Mobility</span></h5>
                                                <p className="mb-0">For a safer transport system in the Philippines.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex flex-column justify-content-center">
                                    <div className="iot-device-content">
                                        <h1 className="iot-title text-uppercase mb-4">The Pasada IoT Device</h1>
                                        <p className="iot-description mb-4">
                                            Mounted on the vehicle's dashboard, the PASADA device uses cameras and motion sensors 
                                            to monitor driver behavior and road conditions in real time, capturing alerts for 
                                            unsafe actions and potential risks.
                                        </p>
                                        <h3 className="alerts-title mb-3">OPERATOR ALERTS INCLUDE:</h3>
                                        <div className="alerts-list">
                                            <div className="alert-item d-flex align-items-center mb-3">
                                                <div className="alert-icon me-3">
                                                    <i className="fas fa-tachometer-alt"></i>
                                                </div>
                                                <span className="alert-text">OVERSPEEDING</span>
                                            </div>
                                            <div className="alert-item d-flex align-items-center mb-3">
                                                <div className="alert-icon me-3">
                                                    <i className="fas fa-route"></i>
                                                </div>
                                                <span className="alert-text">ROUTE DEVIATION</span>
                                            </div>
                                            <div className="alert-item d-flex align-items-center mb-3">
                                                <div className="alert-icon me-3">
                                                    <i className="fas fa-ruler"></i>
                                                </div>
                                                <span className="alert-text">UNSAFE PHYSICAL DISTANCE</span>
                                            </div>
                                            <div className="alert-item d-flex align-items-center mb-3">
                                                <div className="alert-icon me-3">
                                                    <i className="fas fa-exclamation-triangle"></i>
                                                </div>
                                                <span className="alert-text">SUDDEN BRAKES</span>
                                            </div>
                                            <div className="alert-item d-flex align-items-center mb-3">
                                                <div className="alert-icon me-3">
                                                    <i className="fas fa-traffic-light"></i>
                                                </div>
                                                <span className="alert-text">AND OTHER VIOLATED TRAFFIC RULES</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slide>

                <div class="firsts d-flex justify-content-center align-items-center p-4 bg-dark text-light">
                    <Slide right>
                        <div>
                            <img src={require('./images/homeimg/busdriver.jpg')} alt="LOGO" class="images"/>
                        </div>
                    </Slide>
                    <div class="second p-5">
                        <Slide>
                            <h1 className="mt-2">WHY PASADA?</h1>
                            <h4 className="mb-3">It is beneficial to the bus and public utility jeepney drivers by helping them improve
                                and
                                train to be more effective and dependable drivers on the road and professionalize their
                                driving job (increase competence, knowledge, and skills; promote welfare).</h4>
                        </Slide>
                        <button type="button" class="btnarti btn btn-primary btn-rounded"><a href="/about" class="text-decoration-none text-light">Learn
                            More</a></button>
                    </div>
                </div>

                <div class="first d-flex justify-content-center align-items-center bg-light text-dark p-4">
                    <div class="second p-5">
                        <Slide left>
                            <h1 className="mt-2">WHAT IS THE SOLUTION?</h1>
                            <h4 className="mb-3">The Department of Science and Technology – Philippine Council for Industry, Energy and Emerging Technology Research and Development (DOST-PCIEERD), in partnership with the Technological Institute of the Philippines (TIP), is driving innovation in public transport through the PASADA project — an IoT-powered software and hardware solution designed to train, assess, and elevate the performance of Filipino bus and public utility jeepney drivers, while promoting safer, more roadworthy, and more reliable public transport operations.</h4>
                        </Slide>
                        <button type="button" class="btnarti btn btn-primary btn-rounded"><a href="/solution" class="text-decoration-none text-light">Learn
                            More</a></button>
                    </div>
                    <Slide left>
                        <div>
                            <img src={require('./images/homeimg/solution.png')} alt="LOGO" class="images"/>
                        </div>
                    </Slide>
                </div>

                <div class="first d-flex justify-content-center align-items-center p-4 bg-dark text-light">
                    <div class="second p-5">
                        <Slide right>
                            <h1 className="mt-2">THE NEED FOR PASADA</h1>
                            <h4 className="mb-3">There are 3,233 accidents involving buses and 2,562 public utility jeepneys accidents.
                                Moreover, "Human Factor" is the top cause of road crashes like bad overtaking, bad
                                turning,
                                speeding, drunk driving, wrong decision whether to turn left/right, among others.</h4>
                        </Slide>
                        <button type="button" class="btnarti btn btn-primary btn-rounded"><a href="/problem" class="text-decoration-none text-light">Learn
                            More</a></button>
                    </div>
                    <Slide right>
                        <div>
                            <img src={require('./images/homeimg/pasadaimg.jpg')} alt="LOGO" class="images"/>
                        </div>
                    </Slide>
                </div>

                <Slide bottom>
                    <div className="techcontainer d-flex flex-column justify-content-center align-items-center">
                        <h1 className="techno text-uppercase text-dark">Technologies in Pasada</h1>
                        <div className="wrapper m-0 d-grid align-items-center">
                            <div className="card bg-white d-flex flex-column align-items-center">
                                <HashLink to="/about#systems" smooth><img src={require('./images/learningsystems.png')}
                                                                          alt="Learning Systems"
                                                                          className="techimg"/></HashLink>
                                <h2>Learning Systems</h2>
                                <p>(Web Systems, Mobile Application, Modules) for continuous education of truck
                                    drivers.</p>
                            </div>
                            <div className="card bg-white d-flex flex-column align-items-center">
                                <HashLink to="/about#internet" smooth><a href="/about#iot" smooth><img
                                    src={require('./images/iot.png')} alt="IOT" className="techimg"/></a></HashLink>
                                <h2>Internet of Things</h2>
                                <p>Monitors the environment around the bus and puj and drivers behavior on the road.</p>
                            </div>
                            <div className="card bg-white d-flex flex-column align-items-center">
                                <HashLink to="/about#dataanalytics" smooth><img
                                    src={require('./images/dataanalytics.png')} alt="Data Analytics"
                                    className="techimg"/></HashLink>
                                <h2>Data Analytics</h2>
                                <p>Assess and evaluate the bus and puj drivers roadworthiness.</p>
                            </div>
                            <div className="card bg-white d-flex flex-column align-items-center">
                                <HashLink to="/about#ai" smooth><img src={require('./images/ai.png')} alt="AI"
                                                                     className="techimg"/></HashLink>
                                <h2>Artificial Intelligence</h2>
                                <p>Monitors the traffic rules and violation of bus and puj drivers.</p>
                            </div>
                        </div>
                    </div>
                </Slide>
            </div>
        );
    }
}

export default Home;